<div fxLayout="row wrap">
    <div fxFlex="100" class="flex-p"> 
        <div id="leaflet-map"></div>
    </div>
</div>